import { DefaultButton } from '@fluentui/react';
import { ReactElement } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styles from './index.module.sass';
import Auth from "../../Auth/Auth";

interface CartButtonProps
{
    cartLines: any[];
    activePlanType?: number;
}

export default function CartChip(): ReactElement
{
    const isUserSuscribed = Auth.isSubscribed();

    function mapStateToProps(state: any)
    {
        const isUserSuscribedUser = Auth.isSubscribed();
        // Tipo del plan activo desde el store (re-renderiza al cambiar de plan); si aún no se ha hidratado, desde localStorage
        const activePlanType = state.auth?.userActivePlan?.type ?? Auth.getActivePlan()?.type;

        if(!isUserSuscribedUser)
        {
            return { cartLines: state.educationalCart.cartLines, activePlanType: activePlanType };
        }
        else
        {
            return { cartLines: state.cart.cartLines, activePlanType: activePlanType };
        }
    }

    const CartChipChild = connect(mapStateToProps)((props: CartButtonProps) =>
    {
        if(props.cartLines?.length === 0)
        {
            return <></>
        }

        return(
            <div className={styles.CartButtonContainer}>
                {/* Los planes de Educación Financiera (tipo 5) usan su propio carrito también para los suscritos; ruta absoluta (antes "cart-ef" era relativa) */}
                <Link to={!isUserSuscribed || props.activePlanType === 5 ? "/cart-ef" : '/cart'}>
                    <div>
                        <div className={`${styles.Badge} badge`}>{props.cartLines.length}</div>
                        <DefaultButton title="Carrito">
                            <i className="ironia-icon shopping-cart" />
                        </DefaultButton>
                    </div>
                </Link>
            </div>
        )
    });

    return (<CartChipChild />);
}